import api from './index';

export const addRespondentsToGroup = async ({ groupId, respondentIds }) => {
  const result = await api.post(`/groups/${groupId}/respondents`, respondentIds);
  return result;
};
